<template>
  <!-- How It Works -->
  <section class="works-five-section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading car-wash-heading aos" data-aos="fade-up">
            <div class="car-wash-img-five">
              <img src="@/assets/img/icons/car-wash-header-1.svg" alt="image"
                class="car-wash-header-one">
              <h2>How It Works</h2>
              <img src="@/assets/img/icons/car-wash-header-2.svg" alt="image"
                class="car-wash-header-two">
            </div>
            <p>Straightforward process designed to make your experience seamless and hassle-free.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-sm-6 col-12">
          <div class="works-five-main">
            <div class="works-five-img">
              <img src="@/assets/img/works-3.jpg" alt="image">
            </div>
            <div class="works-five-bottom">
              <h5 class="mb-2">Search and Browse</h5>
              <p>Customers can browse or search for specific products or services using categories,
                filters.</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-12">
          <div class="works-five-main">
            <div class="works-five-img">
              <img src="@/assets/img/works-2.jpg" alt="image">
            </div>
            <div class="works-five-bottom">
              <h5 class="mb-2">Add to Cart or Book Now</h5>
              <p>Customers can add items to their shopping cart. For services, they may select a
                best service</p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-6 col-12">
          <div class="works-five-main">
            <div class="works-five-img">
              <img src="@/assets/img/works-1.jpg" alt="image">
            </div>
            <div class="works-five-bottom">
              <h5 class="mb-2">Booking Completion</h5>
              <p>The Customer fulfills the order by either providing the service to the Customers &
                Get leads</p>
            </div>
          </div>
        </div>
      </div>
      <div class="offering-five-all">
        <div class="offering-five-all-img d-none d-md-block">
          <img src="@/assets/img/bubbles-offering-section.png" alt="image">
        </div>
        <div class="row">
          <div class="col-lg-8 col-md-12">
            <div class="offering-five-main">
              <h2>We Are Offering 14 Days Free Trial</h2>
              <p>
                Each service provider will have a listing that typically includes a description of their services, pricing, 
                availability, and any special offers or packages.
              </p>
              <div class="offering-five-button">
                <router-link to="/free-trail" class="btn btn-primary"><i
                    class="ti ti-users me-2 ms-0"></i> Try 14 Days Free Trial</router-link>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-12">
            <div class="offering-five-img d-none d-lg-block">
              <img src="@/assets/img/offering-worker.png" alt="image">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /How It Works -->

  <!-- Featured Services -->
  <section class="feature-category-section-five">
    <div class="container">
      <div class="row">
					<div class="col-md-12 text-center">
						<div class="section-heading car-wash-heading aos" data-aos="fade-up">
							<div class="car-wash-img-five">
								<img src="@/assets/img/icons/car-wash-header-1.svg" alt="image"
									class="car-wash-header-one">
								<h2>Featured Services</h2>
								<img src="@/assets/img/icons/car-wash-header-2.svg" alt="image"
									class="car-wash-header-two">
							</div>
							<p>What do you need to find?</p>
						</div>
					</div>
				</div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel feature-service-five-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexfivecategories" :key="item.id">
                <div class="service-widget flex-fill w-100 aos" data-aos="fade-up">
                  <div class="service-img">
                    <router-link to="/details/service-details">
                      <img class="img-fluid serv-img" alt="Service Image"
                        :src="require(`@/assets/img/car-wash/${item.image}`)">
                    </router-link>
                    <div class="fav-item ">
                      <div class="features-service-five">
                        <div class="features-service-rating">
                          <i class="fas fa-star filled me-1"></i><span>4.9</span>
                        </div>
                      </div>
                      <a href="javascript:void(0)" class="fav-icon fav-icon-five">
                        <i class="feather-heart"></i>
                      </a>
                    </div>
                  </div>
                  <div class="service-content service-feature-five text-start">
                    <h3 class="title">
                      <router-link to="/details/service-details">{{item.title}}</router-link>
                    </h3>
                    <p><i class="feather-map-pin me-2"></i>{{item.location}}</p>
                    <div class="feature-services-five">
                      <h6>{{item.offerprice}}</h6><span>{{item.discountprice}}</span>
                    </div>
                    <div class="feature-service-botton">
                      <div class="d-flex align-items-center ">
                        <img :src="require(`@/assets/img/profiles/${item.avatar}`)" alt="User">
                        <p class="fs-14 mb-0 ms-2">{{item.name}}</p>
                      </div>
                      <div>
                        <router-link to="/details/service-details" class="btn btn-dark">Book Now</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Featured Services -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexfivecategories from "@/assets/json/indexfivecategories.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexfivecategories: indexfivecategories,
      isFavourite: false,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  methods: {
    toggleSelected(event) {
      const element = event.target;
      element.classList.toggle("selected");
    },
  },
};
</script>
